<template>
  <c-accordion>
    <c-accordion-item title="Who will I be working with?">
      I'm Dima, a Canadian software devleoper. You can find out more about me on the
      <router-link to="/about">about page</router-link>. But the most important things are 1) I have over a decade of experience building complex software projects rapidly, 2) I'm a native English speaker, and 3) I reply to questions fast. You might like to
      <router-link to="/contact">contact me</router-link>.
    </c-accordion-item>

    <c-accordion-item
      title="What timezone are you in?"
    >I live in Europe and travel a lot. But since my clients are typically in North America (and much of my family lives near Toronto), I'm most responsive on Eastern Standard Time.</c-accordion-item>

    <c-accordion-item
      title="Do you work alone or with other people?"
    >Unless I get swamped, I work alone. Since I'm working on MVPs that need to get up and running rapidly, I find working alone is faster than getting other developers up to speed. I like the adage, "it takes a woman 9 months to make a baby, but that doesn't mean 9 women can make a baby in a month."</c-accordion-item>

    <c-accordion-item
      title="Why don't you work on already established long term projects?"
    >I used to, but I get bored doing routine maintenance tasks. I love helping clients quickly take a project from zero to one in a predictable, maintainable way. After that I hand it off to developers who prefer stability and routine.</c-accordion-item>

    <c-accordion-item title="Can I see some examples of your work?">
      Absolutely. I've worked on MVP projects in multiple industries. Some of those projects are locked down and can't be discussed, but others are open and public, and I'll be glad to share them.
      <router-link to="/contact">Drop me a note</router-link>, and I'll send over some examples.
    </c-accordion-item>

    <c-accordion-item
      title="What if my client's project is too big for one developer?"
    >That's possible, but I'd recommend cropping it down to the bare minimum that constitutes an MVP (Minimum Viable Product). That would likely fit easily into the work of an experienced solo developer.</c-accordion-item>

    <c-accordion-item
      title="How do I communicate with you? Phone? Email?"
    >While setting up our project, we communicate by phone mostly (or video chat a couple times to meet each other "face to face"). After that we communicate by email mostly, or Slack for quick one-off questions during the work.</c-accordion-item>
  </c-accordion>
</template>

<script>
import CAccordion from "@/components/elements/Accordion.vue";
import CAccordionItem from "@/components/elements/AccordionItem.vue";

export default {
  name: "CFaqHowItWorks",
  components: { CAccordion, CAccordionItem },
  props: {
    startOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
